import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
import { LOSER_VARIANT, MASTER } from '../constants/abVariations';
const fetchAbVariants = ({
  abTestId,
  isLandingPage
}) => {
  const query = {
    abTestId,
    property: ['abStatus', 'analyticsPageId', 'id', 'name', 'url']
  };
  return http.get(`cospages/v2/dashboard/${isLandingPage ? 'landing' : 'site'}-pages`, {
    query
  }).then(({
    objects
  }) => {
    const abVariantList = objects.map(({
      abStatus,
      analyticsPageId,
      id,
      name,
      url
    }) => ({
      abStatus,
      id: analyticsPageId || String(id),
      name,
      pageId: id,
      url: abStatus === MASTER ? `${url}?hsNotRandom=true` : url
    }));
    abVariantList.sort((a, b) => {
      const abStatusA = a.abStatus;
      const abStatusB = b.abStatus;
      if (abStatusA < abStatusB) {
        return -1;
      }
      if (abStatusA > abStatusB) {
        return 1;
      }
      return 0;
    });
    return abVariantList;
  });
};
const AbVariantsQuery = registerQuery({
  fieldName: 'abVariants',
  fetcher: fetchAbVariants
});
const useAbVariants = ({
  abTestId,
  isLandingPage
}) => {
  const {
    data,
    loading,
    error,
    refetch
  } = useQuery(AbVariantsQuery, {
    variables: {
      abTestId: abTestId,
      isLandingPage
    },
    skip: !abTestId
  });
  return useMemo(() => {
    var _data$abVariants;
    return {
      abVariants: data === null || data === void 0 ? void 0 : data.abVariants,
      liveAbVariants: data === null || data === void 0 || (_data$abVariants = data.abVariants) === null || _data$abVariants === void 0 ? void 0 : _data$abVariants.filter(variant => variant.abStatus !== LOSER_VARIANT),
      abRequestLoading: loading,
      abRequestError: error,
      refetchAbVariants: refetch
    };
  }, [data, error, loading, refetch]);
};
export default useAbVariants;